/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ReactSparkSelectInput } from '../../widgets/index';
import ConfigManage from './configurationListSettings/index';

class MenuContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedLanguage: props.defaultLanguageCode || 'en-US',
            menuContentByLanguages: {},
            listOfLanguages: _.sortBy(props.languageList, ['name'])
        };
    }

    componentDidMount() {
        const { selectedLanguage } = this.state;
        const { changeCustomContentLanguageCode } = this.props;

        const { hotelMenuContent, hotelMenuContentByLanguages } = this.props.currentConfigCopy;
        changeCustomContentLanguageCode(selectedLanguage);

        if (!_.isEmpty(hotelMenuContentByLanguages)) {
            this.filterMenuContet(hotelMenuContentByLanguages);
        } else if (!_.isEmpty(hotelMenuContent)) {
            this.filterMenuContet(hotelMenuContent);
        } else {
            this.filterMenuContet({});
        }
    }

    componentDidUpdate(prevProps) {
        const prevMenuContent = prevProps.currentConfigCopy.hotelMenuContent;
        const prevMenuContentByLanguages = prevProps.currentConfigCopy.hotelMenuContentByLanguages;
        const currentMenuContent = this.props.currentConfigCopy.hotelMenuContent;
        const currentMenuContentByLanguages = this.props.currentConfigCopy.hotelMenuContentByLanguages;

        if (!_.isEqual(prevMenuContentByLanguages, currentMenuContentByLanguages)) {
            this.setState(
                {
                    listOfLanguages: _.sortBy(this.props.languageList, ['name'])
                },
                () => {
                    const isContentByLanguagesEmpty = _.isEmpty(currentMenuContentByLanguages);
                    this.filterMenuContet(
                        isContentByLanguagesEmpty ? currentMenuContent || {} : currentMenuContentByLanguages
                    );
                }
            );
        } else if (!_.isEqual(prevMenuContent, currentMenuContent)) {
            this.setState(
                {
                    listOfLanguages: _.sortBy(this.props.languageList, ['name'])
                },
                this.filterMenuContet(currentMenuContent || {})
            );
        }
    }

    onLanguageChange = event => {
        const selectedLanguage = event.target.value;

        this.setState({ selectedLanguage }, this.props.changeCustomContentLanguageCode(selectedLanguage));
    };

    filterMenuContet = hotelMenuContent => {
        if (_.isArray(hotelMenuContent)) {
            const { listOfLanguages } = this.state;
            const menuContentByLanguages = {};

            listOfLanguages.forEach(language => {
                menuContentByLanguages[language.code] = hotelMenuContent;
            });

            return this.setState({ menuContentByLanguages });
        }

        if (_.isObject(hotelMenuContent)) {
            return this.setState({
                menuContentByLanguages: hotelMenuContent
            });
        }

        this.setState({
            menuContentByLanguages: {}
        });
    };

    setMenuContentsToLanguage = menuContent => {
        const { menuContentByLanguages } = this.state;
        const { languageCode, saveHotelMenuContent } = this.props;

        this.setState(
            {
                menuContentByLanguages: {
                    ...menuContentByLanguages,
                    [languageCode]: menuContent
                }
            },
            () => saveHotelMenuContent(this.state.menuContentByLanguages)
        );
    };

    addConfigRow = () => {
        const menuContent = _.get(this.state.menuContentByLanguages, this.props.languageCode, []);

        this.setMenuContentsToLanguage([...menuContent, '']);
    };

    editConfigRow = (editCode, index, value) => {
        const menuContent = _.get(this.state.menuContentByLanguages, this.props.languageCode, []);
        menuContent[index] = value;

        this.setMenuContentsToLanguage(menuContent);
    };

    deleteConfigRow = index => {
        const menuContent = _.get(this.state.menuContentByLanguages, this.props.languageCode, []);

        this.setMenuContentsToLanguage(menuContent.filter((elem, idx) => idx !== index));
    };

    render() {
        const { isDisabled, languageList, languageCode } = this.props;
        const { menuContentByLanguages } = this.state;
        const currentList = _.get(menuContentByLanguages, this.props.languageCode, []);
        const languageListSorted = _.sortBy(languageList, ['name']);

        return (
            <div className="spark-panel__content">
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h3>Hotel Settings</h3>
                    </div>
                </section>
                <section className="row spark-panel__section">
                    <div className="col-xs-4">
                        <ReactSparkSelectInput
                            label="Label Language"
                            defaultValue={languageCode}
                            values={languageListSorted.map(v => {
                                return { key: v.code, label: v.name };
                            })}
                            onChange={this.onLanguageChange}
                            disabled={isDisabled}
                        />
                    </div>
                </section>
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h4>Hotel Menu Content</h4>
                        <ConfigManage
                            list={currentList}
                            isDisabled={isDisabled}
                            addConfigRow={this.addConfigRow}
                            editConfigRow={this.editConfigRow}
                            deleteConfigRow={this.deleteConfigRow}
                            firstColumn="Hotel Menu Link"
                            single
                        />
                    </div>
                </section>
            </div>
        );
    }
}

MenuContent.propTypes = {
    changeCustomContentLanguageCode: PropTypes.func.isRequired,
    defaultLanguageCode: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    languageCode: PropTypes.string.isRequired,
    languageList: PropTypes.shape({
        name: PropTypes.string,
        code: PropTypes.string
    }).isRequired,
    saveHotelMenuContent: PropTypes.func.isRequired,
    currentConfigCopy: PropTypes.shape({
        hotelMenuContent: PropTypes.array,
        hotelMenuContentByLanguages: PropTypes.object
    }).isRequired
};

export default MenuContent;



// WEBPACK FOOTER //
// ./src/components/pages/pages/MenuContent.js